import { render, staticRenderFns } from "./AppCargandoComponent.vue?vue&type=template&id=5aea4672"
import script from "./AppCargandoComponent.vue?vue&type=script&lang=js"
export * from "./AppCargandoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports